export const MAP_STYLE = [
    { "featureType": "administrative", "elementType": "geometry", "stylers": [ { "visibility": "off" } ] },
    { "featureType": "administrative.neighborhood", "stylers": [ { "visibility": "off" } ] },
    { "featureType": "poi", "stylers": [ { "visibility": "off" } ] },
    { "featureType": "road", "stylers": [ { "visibility": "on" } ] },
    { "featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off"  } ] },
    { "featureType": "transit", "stylers": [ { "visibility": "off" } ] },
    { stylers: [ { lightness: 0, }, { saturation: 0 } ] }
]

export const MAP_CONFIG: google.maps.MapOptions = {
    center: { lat: 40.419348, lng: -3.700897 },
    zoom: 16,
    disableDefaultUI: true,
    zoomControl: true,
    clickableIcons: false
}
